export class CompanyAudioRecordingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAudioRecordings() {
    return this.#http.get('/AudioRecording/company');
  }

  async editAudioRecording({ audioRecordingId, ...body }) {
    return this.#http.put(`/AudioRecording/company/${audioRecordingId}`, body);
  }

  async createAudioRecording(body) {
    return this.#http.post('/AudioRecording/company', body);
  }
}
